import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-plus",
  "use": "icon-cl-plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-plus\"><rect x=\"8.5\" y=\"13.5\" width=\"1\" height=\"11\" rx=\".5\" transform=\"rotate(-180 8.5 13.5)\" /><rect x=\"2.5\" y=\"8.5\" width=\"1\" height=\"11\" rx=\".5\" transform=\"rotate(-90 2.5 8.5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol